export type BeneficiaryHomonymsSearchedPayload = {
	readonly totalRecords: number;
	// Mutable at the top level: `synapse`'s action payload only accepts `Record<string, unknown>`, and a
	// `readonly` array head is not assignable to it.
	beneficiaryIds: number[];
};

export type BeneficiaryHomonymsSearchedAction = {
	type: 'BENEFICIARY_HOMONYMS_SEARCHED';
	payload: BeneficiaryHomonymsSearchedPayload;
	facilityId: number;
};

export default (
	payload: BeneficiaryHomonymsSearchedPayload,
	facilityId: number,
): BeneficiaryHomonymsSearchedAction => ({
	type: 'BENEFICIARY_HOMONYMS_SEARCHED',
	payload,
	facilityId,
});
